import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Column } from 'components/shared/Layout';
import { legShape, productsShape } from 'constants/propTypes';
import { directions } from 'constants/booking';
import SegmentOrdering from './SegmentOrdering';

const SegmentSummaryColumn = ({
  legs = [],
  productFamilyName,
  productFamilies,
  direction,
  currency,
  groupName = '',
  isMiceGroupBooking,
  infantPassengers = [],
  isLoyaltyBooking = false
}) => (
  <Column span={8} data-cy={`segment-summary-${direction}`} className={`segment-summary-${direction}`}>
    <h2>
      <FormattedMessage id={`journeySummary.${direction}`} />
    </h2>

    {legs.map((leg) => (
      <SegmentOrdering
        key={leg.id}
        leg={leg}
        addOnLeg={leg.addOnLeg}
        currency={currency}
        productFamilyName={productFamilyName}
        productFamilies={productFamilies}
        direction={direction}
        groupName={groupName}
        isMiceGroupBooking={isMiceGroupBooking}
        infantPassengers={infantPassengers}
        isLoyaltyBooking={isLoyaltyBooking}
      />
    ))}
  </Column>
);

SegmentSummaryColumn.propTypes = {
  currency: PropTypes.string,
  direction: PropTypes.oneOf(directions).isRequired,
  legs: PropTypes.arrayOf(legShape),
  productFamilyName: PropTypes.string,
  groupName: PropTypes.string,
  productFamilies: productsShape,
  isMiceGroupBooking: PropTypes.bool,
  infantPassengers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      passengerRef: PropTypes.string
    })
  ),
  isLoyaltyBooking: PropTypes.bool
};

export default SegmentSummaryColumn;
